import AdditionalMaterials from '../../components/calculation-form/components/form-items/additional-materials'
import AdditionalMaterialsNames from '../../components/calculation-form/components/other/additional-materials-names'
import { renderCalcPos } from '../../helpers/helpers'
import isCalculation from '../../helpers/is-calculation'
import type { CalculationColumn } from '../../types/column-types'

export const additionalMaterialsColumn: CalculationColumn = {
    dataIndex: ['additional_materials'],
    title: 'Коррект. ширин доп.',
    relationPath: ['additional_materials'],
    width: 80,
    editable: true,
    FormItem: <AdditionalMaterials />,
    onCell: record => {
        if (isCalculation(record)) {
            return { colSpan: 0 }
        } else {
            return { colSpan: 1, style: { maxWidth: 80 } }
        }
    },
    render: renderCalcPos(r => <AdditionalMaterialsNames data={r} />),
}
